import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Container, Glow } from './ui';
import { Stagger, StaggerItem } from './motion';

const FinalCTA = () => (
  <section id="get-started" className="relative py-24 sm:py-32">
    <Container>
      <div className="relative overflow-hidden rounded-[2.5rem] border border-white/10 bg-gradient-to-b from-ink-800 to-ink-950 px-6 py-20 text-center sm:px-16 sm:py-28">
        <div aria-hidden="true" className="absolute inset-0 bg-grid-fade bg-[size:48px_48px] [mask-image:radial-gradient(ellipse_at_center,black_10%,transparent_70%)]" />
        <Glow className="left-1/2 top-0 h-80 w-[40rem] -translate-x-1/2 -translate-y-1/2 bg-brand-500/30" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-300/60 to-transparent" />

        <Stagger className="relative mx-auto max-w-3xl" stagger={0.1}>
          <StaggerItem
            as="h2"
            className="text-gradient text-4xl font-extrabold tracking-tight sm:text-6xl lg:text-7xl"
          >
            Ready to Simplify Your Group Finances?
          </StaggerItem>
          <StaggerItem as="p" className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-slate-400 sm:text-xl">
            Join thousands of groups who are already enjoying stress-free, transparent financial collaboration.
          </StaggerItem>
          <StaggerItem className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <a href="#top" className="btn-primary group w-full sm:w-auto">
              Get Started for Free
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </a>
            <a href="#features" className="btn-secondary w-full sm:w-auto">
              Learn More
            </a>
          </StaggerItem>
        </Stagger>
      </div>
    </Container>
  </section>
);

export default FinalCTA;
